// removed by extract-text-webpack-plugin
module.exports = {"container":"-tWaHKN-PNcHjSyjtDfGt","pending":"_37Jn6dwxoYxFIfdNpbctg","medium":"_2DabIf4a9hTBpMqIt8FB7e","large":"_2OSfbkOSpyN-0VAUW3-KEJ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/Document/Page/Field/Show/Text/styles.css
// module id = 2916
// module chunks = 0